module.exports = __webpack_public_path__ + "img/ds9.b9d06f6b.png";